import React from "react";
import * as _ from "lodash";
import "../../Invs/AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead, WaterMarkName } from "../../Invs/ShareFunctionsPrint";
import FooterA from "../../Safes/Jard/A4/FooterA";
import HeaderConferm from "./HeaderConferm";
import BodyConferm from "./BodyConferm";
function HeadersNew(props) {
    const { found, dataConfirm } = props;
    return (
        <div style={stylePaddingHead}>
            <HeaderConferm found={found} dataConfirm={dataConfirm} />
        </div>
    );
}
function BodyPrint(props) {
    const { found, dataConfirm } = props;
    return (
        <div style={stylePadding}>
            <BodyConferm found={found} dataConfirm={dataConfirm} />
        </div>
    );
}
function Footers(props) {
    const { found } = props;
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <FooterA found={found} />
        </div>
    );
}
function AccountsConfirmCon(props) {
    const { info, dataConfirm } = props;
    return (
            <div className="invoicepreview">
                <div className="pageinv" >
                    <WaterMarkName found={info} />
                    <div className="contentview">
                        <HeadersNew found={info} dataConfirm={dataConfirm} />
                        <BodyPrint found={info} dataConfirm={dataConfirm}  />
                    </div>
                    <Footers found={info} />
                </div>
            </div>
    );
}
export default AccountsConfirmCon;
